module.exports = __webpack_public_path__ + "img/bg_branding.198afc0f.png";